"use strict";
/* eslint-disable no-mixed-operators */
Object.defineProperty(exports, "__esModule", { value: true });
const isPointInsidePolygon = (poly, point) => {
    let isInside;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i, i += 1) {
        if ((((poly[i][0] <= point[0]) && (point[0] < poly[j][0]))
            || ((poly[j][0] <= point[0]) && (point[0] < poly[i][0])))
            && (point[1] < (poly[j][1] - poly[i][1]) * (point[0] - poly[i][0])
                / (poly[j][0] - poly[i][0]) + poly[i][1])) {
            isInside = !isInside;
        }
    }
    return isInside;
};
exports.default = isPointInsidePolygon;
